import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { KundeslaListView } from "./list-view/kundesla.list-view";

export const kundeslaFieldOk: FieldOkConfig = {
  name: 'kundesla',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{bereich}}: {{dokumentation}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: KundeslaListView
    }
  }
  ]
};
export const kundeslaMultiselectFieldOk: FieldOkConfig = {
  name: 'kundesla',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{bereich}}: {{dokumentation}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: KundeslaListView
    }
  }
  ]
};

export const kundeslaQueryFieldOk: FieldOkConfig = {
  name: 'kundesla',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{bereich}}: {{dokumentation}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: KundeslaListView
    }
  }
  ]
};
